import React, {useCallback, useEffect, useRef, useState} from "react";
import CountryCodeJson from "../assets/countryCode.json";

const CountryCodePicker = (props) => {
    let {countryCode = "+44", onChange} = props
    const [visibleTypehead, setVisibleTypehead] = useState(false);
    const containerRef = useRef(null);

    const [searchTerm, setSearchTerm] = useState('');

    // Click outside handler
    const handleClickOutside = useCallback((event) => {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
            setVisibleTypehead(false);
        }
    }, []);

    useEffect(() => {
        if (visibleTypehead) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [visibleTypehead, handleClickOutside]);

    const filteredCountries = CountryCodeJson.filter(item =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.dialCode.includes(searchTerm)
    );


    return (
        <div className={'country-picker content'} ref={containerRef} onClick={() => setVisibleTypehead(true)}
             style={{width: 80}}>
            <div className={'selected-country'}>
                {countryCode}
            </div>
            {visibleTypehead ?
                <div className={'country-dropdown'}>
                    <input className={'form-control'} placeholder={'Search'}
                           value={searchTerm}
                           onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <ul key={filteredCountries}>
                        {filteredCountries.map((item) => {
                            return (
                                <li key={item.dialCode} onClick={() => {
                                    onChange(item.dialCode)
                                    setTimeout(() => setVisibleTypehead(false), 100)
                                    setSearchTerm('');
                                }}>
                                    {item.emoji} &nbsp;{item.dialCode} &nbsp;
                                    <span>{item.name}</span>
                                </li>
                            )
                        })}
                    </ul>
                </div> : null}
        </div>
    )
}

export default CountryCodePicker
